"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationTypes = void 0;
var NotificationTypes;
(function (NotificationTypes) {
    NotificationTypes["RatingScreenTitle"] = "rating_screen_title";
    NotificationTypes["PostRatingPositiveTitle"] = "post_rating_positive_title";
    NotificationTypes["PostRatingNegativeTitle"] = "post_rating_negative_title";
    NotificationTypes["CxSchedulingCustomerMessageTitle"] = "cx_scheduling_customer_message_title";
    NotificationTypes["CxSchedulingFreeCommentInputLabel"] = "cx_scheduling_free_comment_input_label";
})(NotificationTypes || (exports.NotificationTypes = NotificationTypes = {}));
//# sourceMappingURL=notification_type.js.map